import Box from '@mui/material/Box';
import React from 'react';
import { Outlet } from 'react-router';
import NoInvitationHeading from './NoInvitationHeading';

const LoginNoInvitationLayout = () => (
  <Box>
    <NoInvitationHeading />
    <Outlet />
  </Box>
);

export default LoginNoInvitationLayout;
